module.exports = "/assets/data/09c347cc943edbfb726b355829b8976b-BD22.data.json";